import { fetchJsonWithSupabaseAuth, QA_API_DOMAIN } from "@/api/classifier";

export interface SubmitRelevanceReviewRequest {
  relevant: boolean;
  reason: string;
}

export interface SubmitRelevanceReviewResponse {
  ok: true;
  rawBundleId: string;
}

export async function submitRelevanceReview(
  encounterId: string,
  rawBundleId: string,
  body: SubmitRelevanceReviewRequest,
): Promise<SubmitRelevanceReviewResponse> {
  return fetchJsonWithSupabaseAuth<SubmitRelevanceReviewResponse>(
    `${QA_API_DOMAIN}/relevance-review/encounter/${encounterId}/bundle/${rawBundleId}/submit`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    },
  );
}
